<template>
	<div class='result-table-mzl'>

		<table class='table-common mzl-table'>
			<thead>
				<tr>
					<th>Целевое назначение лесов</th>
					<th>Группа возраста</th>
					<th>Категория защитных лесов</th>
					<th>Водоохранная зона не указ в лу</th>
					<th>ОЗУ по ТО</th>
					<th>Естественное низкополнотное</th>
					<th>Лесные насаждения 4 и 5 бонитетов являются преобладающими в лесничестве</th>
					<!-- <th>Вид разрешенного использования леса</th> -->
					<th>ОЗУ по факту</th>
					<th>ООПТ</th>
					<th>Остаточная полнота меньше критической</th>
					<th>Остаточная полнота не лимитируется</th>
					<th>
						<!-- Неликвида и дров <= 90 -->
						<a href='#'  v-tooltip.bottom='"открыть cсылку на НПА"' @click.prevent='toggleOP'>Неликвида и дров <= 90</a>
					</th>
					<th>Ели и пихты < 70</th>
				</tr>
			</thead>
			<tbody>
				<template v-if='dataIsLoading'>
					<div class='table-common__loading-container'>
						<div>
							<p-spinner class='table-common__loading-spinner'/>
						</div>
						<div class='table-common__loading-text'>Загрузка данных...</div>
					</div>
				</template>

				<template v-if='dataIsLoading && !tableData.length'>
					<tr>
						<td colspan='20' class='table-common__loading-empty-row'></td>
					</tr>
				</template>

				<template v-else>
					<tr v-for='row in tableData'>
						<td>{{ row.forest_purpose }}</td>
						<td>{{ row.age_group }}</td>
						<td>{{ row.protection_category }}</td>
						<td>{{ row.is_water_protection_zone === 't' ? uCheck : '' }}</td>
						<td>{{ row.is_to_ozu === 't' ? uCheck : '' }}</td>
						<td>{{ row.is_low_density_natural === 't' ? uCheck : '' }}</td>
						<td>{{ row.is_low_bonitet_natural === 't' ? uCheck : '' }}</td>
						<!-- <td>{{ row.forest_use }}</td> -->
						<td>{{ row.is_lpo_ozu === 't' ? uCheck : '' }}</td>
						<td>{{ row.is_oopt === 't' ? uCheck : '' }}</td>
						<td>{{ row.is_final_density_less_critical === 't' ? uCheck : '' }}</td>
						<td>{{ row.is_final_density_not_limited === 't' ? uCheck : '' }}</td>
						<td>{{ row.is_illiquid_pct_less_or_equal_90 === 't' ? uCheck : '' }}</td>
						<td>{{ row.is_fir_pct_less_70 === 't' ? uCheck : '' }}</td>
					</tr>
				</template>
			</tbody>
		</table>

		<table class='table-common mzl-table'>
			<thead>
				<tr>
					<th>СКС насаждения <= 2,5</th>
					<th>Угроза возниконовения пожарной опасности</th>
					<th>Угроза возникновения очагов</th>
					<th>Преобладающая порода Дуб, Каштан, Кедр*</th>
					<th>Наличие погибших семенников</th>
					<th>насаждения 4 и 5 бонитетов</th>
					<th>Объем пат. отпада в 2 и более раз превышает объем ест. отпада</th>
					<th>Расчетная интенстивность ВСР менее 70 %</th>
					<th>Интенсивность УНД более 50 %** - способ ЛПО БВ-50</th>
				</tr>
			</thead>
			<tbody>
				<template v-if='dataIsLoading'>
					<div class='table-common__loading-container'>
						<div>
							<p-spinner class='table-common__loading-spinner'/>
						</div>
						<div class='table-common__loading-text'>Загрузка данных...</div>
					</div>
				</template>

				<template v-if='dataIsLoading && !tableData.length'>
					<tr>
						<td colspan='20' class='table-common__loading-empty-row'></td>
					</tr>
				</template>

				<template v-else>
					<tr v-for='row in tableData'>
						<td>{{ row.is_total_sks_not_enough === 't' ? uCheck : '' }}</td>
						<td>{{ row.is_fire_hazard === 't' ? uCheck : '' }}</td>
						<td>{{ row.is_pest_core_hazard === 't' ? uCheck : '' }}</td>
						<td>{{ row.is_oak_chestnut_cedar_first === 't' ? uCheck : '' }}</td>
						<td>{{ row.is_dead_seed_trees === 't' ? uCheck : '' }}</td>
						<td>{{ row.is_4_or_5_bonitet === 't' ? uCheck : '' }}</td>
						<td>{{ row.is_more_double_loss === 't' ? uCheck : '' }}</td>
						<td>{{ row.is_felling_pct_less_70  === 't' ? uCheck : ''}}</td>
						<td>{{ row.is_vb_50 === 't' ? uCheck : '' }}</td>
					</tr>
				</template>
			</tbody>
		</table>

		<p-overlay-panel ref="op">
			<div class='p-text-bold p-mb-2'>{{ NPA_REF_TITLE }}</div>
			<div>{{ NPA_REF_TEXT }}</div>
		</p-overlay-panel>

	</div>
</template>

<script>
	// import npaRefs from '@/lib/npaRefs.js';
	const GET_TABLE_DATA = process.env.VUE_APP_ROOT_API + 'get_site_data/result_tables/tableMzl.php';

	const NPA_REF_TITLE = `П. 57 Правил осуществления мероприятий по предупреждению распространения вредных организмов, утвержденных Приказом Минприроды России от 09.11.2020 № 912.`;
	const NPA_REF_TEXT = `Уборка неликвидной древесины проводится в местах образования ветровала, бурелома, снеголома, верховых пожаров и других повреждений при наличии неликвидной и дровяной древесины более 90% от общего запаса погибших и поврежденных деревьев, а также в случаях, когда заготовка древесины погибших или поврежденных насаждений запрещена.
В первую очередь уборка неликвидной древесины производится в лесах, выполняющих функции защиты природных и иных объектов, а также в ценных лесах. На землях другого целевого назначения и иных категорий защитных лесов уборка неликвидной древесины производится в случае, если создается угроза пожарной опасности в лесах и возникновения очагов вредных организмов.`;

	export default {
		name: 'ResultTableMzl',
		data: () => ({
			tableData: [],
			dataIsLoading: false,

			NPA_REF_TITLE,
			NPA_REF_TEXT
		}),
		computed: {
			lpo() {
				return this.$store.state.selectedLpo.lpo;
			},

			uCheck() {
				return '\u2713';
			}

		},

		watch: {
			lpo(lpo) {
				this.getTableData();
			}
		},

		methods: {
			toggleOP(event) {
				this.$refs.op.toggle(event);
			},

			getTableData() {
				this.dataIsLoading = true;

				const form = new FormData();
				form.append('lpo_id', this.lpo.lpo_id);

				fetch(GET_TABLE_DATA, {
					credentials: 'include',
					method: 'post',
					body: form
				})
				.then(res => res.json())
				.then(res => {
					this.tableData = res;
				})
				.catch(err => { throw err })
				.finally(() => { this.dataIsLoading = false; });


			}
		},
		created() {
			this.getTableData();
		}
	};
</script>

<style lang='scss' scoped src='@/style/tables.scss'></style>

<style scoped>
	.mzl-table:first-child {
		margin-bottom: 2rem;
	}
</style>